module.exports = __webpack_public_path__ + "static/media/hireHover.cbb526ac.svg";